import { render, staticRenderFns } from "./wgpmsj.vue?vue&type=template&id=c8466c36&scoped=true&"
import script from "./wgpmsj.vue?vue&type=script&lang=js&"
export * from "./wgpmsj.vue?vue&type=script&lang=js&"
import style0 from "./wgpmsj.vue?vue&type=style&index=0&id=c8466c36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8466c36",
  null
  
)

export default component.exports